import { useLoading } from './ProgressContext';

const SubscriptionService = () => {
  // Create an Axios instance
  const { axiosInstance } = useLoading(); // Use the Axios instance from context

  const api = axiosInstance;

  // Define the service methods
  const getSubscriptions = async () => {
    try {
      const response = await api.get('api/Subscription/GetSubscriptions');
      return response.data;
    } catch (error) {
      console.error('Error getting subscriptions:', error);
      throw error;
    }
  };

   const getAllSubscriptions = async (user, siActive, pageSize) => {
    try {
      const response = await api.get(`api/SubscriptionAdmin/GetAllSubscriptions?user=${user || '-'}&siActive=${siActive || null}&pageSize=${pageSize || 5}`);
      return response.data;
    } catch (error) {
      console.error('Error getting subscriptions:', error);
      throw error;
    }
  };

  // post method for userEmail, packageId and paidAmount
    const addSubscription = async (data) => {
        try {
        const response = await api.post(`api/SubscriptionAdmin/AddSubscription`, data);
        return response.data;
        } catch (error) {
        console.error('Error adding subscription:', error);
        throw error;
        }
    };

  
  // Return all methods as an object
  return {
    getSubscriptions,
    getAllSubscriptions,
    addSubscription,   
  };
};

export default SubscriptionService;